var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_254_1116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_254_1116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67952 12.542C3.38863 12.542 3.14013 12.439 2.93402 12.233C2.72801 12.0269 2.625 11.7784 2.625 11.4875V6.01318C2.625 5.72229 2.72801 5.47379 2.93402 5.26768C3.14013 5.06167 3.38863 4.95866 3.67952 4.95866H8.75V3.79199C8.75 3.30588 8.57986 2.89269 8.23958 2.55241C7.89931 2.21213 7.48611 2.04199 7 2.04199C6.57669 2.04199 6.20725 2.17528 5.89167 2.44187C5.57608 2.70855 5.37605 3.03969 5.29156 3.43528C5.26385 3.54145 5.20513 3.62744 5.1154 3.69326C5.02566 3.75908 4.92469 3.79199 4.8125 3.79199C4.68835 3.79199 4.58442 3.75067 4.50071 3.66803C4.4169 3.58539 4.38584 3.48798 4.40752 3.37578C4.50999 2.74987 4.80428 2.22526 5.2904 1.80195C5.77651 1.37864 6.34637 1.16699 7 1.16699C7.72839 1.16699 8.34799 1.42239 8.85879 1.9332C9.3696 2.44401 9.625 3.0636 9.625 3.79199V4.95866H10.3205C10.6114 4.95866 10.8599 5.06167 11.066 5.26768C11.272 5.47379 11.375 5.72229 11.375 6.01318V11.4875C11.375 11.7784 11.272 12.0269 11.066 12.233C10.8599 12.439 10.6114 12.542 10.3205 12.542H3.67952ZM3.67952 11.667H10.3205C10.3729 11.667 10.4159 11.6502 10.4495 11.6165C10.4832 11.5829 10.5 11.5399 10.5 11.4875V6.01318C10.5 5.96078 10.4832 5.91776 10.4495 5.88412C10.4159 5.85048 10.3729 5.83366 10.3205 5.83366H3.67952C3.62712 5.83366 3.5841 5.85048 3.55046 5.88412C3.51682 5.91776 3.5 5.96078 3.5 6.01318V11.4875C3.5 11.5399 3.51682 11.5829 3.55046 11.6165C3.5841 11.6502 3.62712 11.667 3.67952 11.667ZM7 9.77116C7.2834 9.77116 7.52442 9.67189 7.72304 9.47337C7.92157 9.27474 8.02083 9.03373 8.02083 8.75033C8.02083 8.46692 7.92157 8.22591 7.72304 8.02728C7.52442 7.82876 7.2834 7.72949 7 7.72949C6.7166 7.72949 6.47558 7.82876 6.27696 8.02728C6.07843 8.22591 5.97917 8.46692 5.97917 8.75033C5.97917 9.03373 6.07843 9.27474 6.27696 9.47337C6.47558 9.67189 6.7166 9.77116 7 9.77116Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.ef4019d0ec9013a36727568f2e68de53.svg";
export { ForwardRef as ReactComponent };